import {makeStyles} from "@material-ui/core";
import {
  CREATOR_MOBILE_TABLE_HEADER
} from "../../../../../config/mock";
import {CreatorTableHeader} from "../../../../atoms/tables/dashboardTableHeader";
import clsx from "clsx";
import UtilService from "../../../../../helper/service";
import {initAnalysisData} from "../../../../../store/actions/creator/analysis";
import {
  getSessionParticipantsSuccess,
  initLiveAnalysisData
} from "../../../../../store/actions/creator/creatorExperienceManager";
import roles from "../../../../../helper/roles";
import {useHistory} from "react-router";
import {useDispatch} from "react-redux";

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    padding: '0 15px',
    borderRadius: 10,
    marginTop: 15,
    boxShadow: '0px 0px 4px #00000033',
  },
  body: {
    position: 'sticky',
    marginBottom: 20
  },
  row: {
    background: '#fff',
  },
  tr: {
    height: 80,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: 'roboto-regular',
    color: '#697683',
    fontSize: 14,
    cursor: 'pointer',
    borderBottom: '1px solid #F5F5F5',
    '@media only screen and (max-width: 374px)': {
      height: 60,
      fontSize: 11
    },
    '& div': {
      textAlign: 'left',
    }
  },
  img: {
    width: 100,
    height: 60,
    borderRadius: 10,
    marginRight: 15,
    objectFit: 'cover',
    '@media only screen and (max-width: 374px)': {
      width: 84,
      height: 50,
      marginRight: 10
    }
  },
  imgDiv: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  mp3Icon: {
    width: '38px',
    height: '38px',
    position: 'absolute',
    textAlign: 'center',
    marginLeft: '-33px',
  },
  left: {
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center'
  },
  name: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  benchmarkIcon: {
    width: 12,
    height: 12,
    marginRight: 5,
    marginLeft: -10
  },
  iconHidden: {
    visibility: 'hidden'
  }
}));

interface IProps {
  sessions: any
}

const MobileCreatorTable = (props: IProps) => {
  const classes = useStyles();
  const { sessions } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : {};

  const goManagerPage = (item: any) => {
    dispatch(initAnalysisData());
    dispatch(initLiveAnalysisData());
    if (!item.session_code) return;
    dispatch(getSessionParticipantsSuccess(null));
    localStorage.setItem("session_code", String(item.session_code));
    localStorage.setItem("session_id", String(item.session_id));
    localStorage.setItem("session_name", String(item.name));

    let routertabname = 'participants';
    switch (item.status.toLowerCase()) {
      case "upcoming":
        routertabname = "participants";
        break;
      case "completed":
        routertabname = "overview";
        break;
      case "live":
        routertabname = "analyze";
        break;
      case "compare":
        routertabname = "compare";
        break;
      default:
        break;
    }
    let url = `/creator/experience-manager/${routertabname}/${item.session_code}`;
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['experiences'])) {
      url = `/subscriber/creator/experience-manager/${routertabname}/${item.session_code}`;
    }
    history.push(url, { session_id: item.session_id });
  };

  return (
    <div className={classes.root}>
      <CreatorTableHeader
        data={CREATOR_MOBILE_TABLE_HEADER}
        isMobile={true}
      />
      <div className={clsx(classes.body)}>
        {
          sessions.map((item: any, index: number) =>
            <div
              key={index}
              className={classes.row}
            >
              <div className={classes.tr}>
                <div style={{ width: CREATOR_MOBILE_TABLE_HEADER[0].width }} className={classes.left} onClick={() => goManagerPage(item)}>
                  <div className={classes.imgDiv}>
                    <img
                      src={item.img_large}
                      alt={'img'}
                      className={classes.img}
                      onError={e => e.currentTarget.src = '/assets/images/video-processing.png'}
                    />
                    {(item.stimulus_type === 'AUDIO') && (
                      <img
                        src={`/assets/icons/mp3.svg`}
                        alt={'img'}
                        className={classes.mp3Icon}
                        onError={e => e.currentTarget.src = '/assets/images/video-processing.png'}
                      />
                    )}
                  </div>
                  {item.saved_benchmark ? (
                    <img src={'/assets/icons/dashboard/dashboard-star.svg'} className={classes.benchmarkIcon} />
                  ) : (
                    <img src={'/assets/icons/dashboard/dashboard-star.svg'} className={clsx(classes.benchmarkIcon, classes.iconHidden)} />
                  )}
                  <div className={classes.name}>{item.name}</div>
                </div>
                <div style={{ width: CREATOR_MOBILE_TABLE_HEADER[1].width }} onClick={() => goManagerPage(item)}>
                  {UtilService.formattingString(item.status)}
                </div>
              </div>
            </div>
          )
        }
      </div>
    </div>
  )
};

export default MobileCreatorTable;